import { Route } from '@angular/router';
import { TenderDocumentsResolver, TenderCoverLetterResolver } from '../../../resolvers';
import {CurrenciesNoCentsResolver, TenderTypesResolver, UnitsResolver} from '../../../../../common/routing/resolvers';
import { TimezonesResolver } from '../../../../../geodata/routing/resolvers';
import { CreateTenderDetailsComponent } from '../../../../pages';
import { TenderStepGuard } from '../../../guards';

export const createTenderDetailsRoute: Route = {
    path: 'details',
    component: CreateTenderDetailsComponent,
    canActivate: [TenderStepGuard],
    resolve: {
        timezonesCollection: TimezonesResolver,
        unitsCollection: UnitsResolver,
        currencyCollection: CurrenciesNoCentsResolver,
        documents: TenderDocumentsResolver,
        coverLetter: TenderCoverLetterResolver,
        tenderTypes: TenderTypesResolver
    }
};
